<template>
  <div class="level">
    <div class="level-left">
      <div>
        <h1 class="vs-title">
          {{ title }}
        </h1>
        <h2
          v-if="subTitle"
          class="vs-subtitle"
        >
          {{ subTitle }}
        </h2>
      </div>
    </div>
    <div class="level-right">
      <slot name="rightElements" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    subTitle: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="scss">
.level-right {
  min-width: 25%;
}

.level-left {
  max-width: 100%;
}

.vs-title {
  font-size: 39px;
}

.vs-subtitle {
  color: $gray-500;
  font-size: 20px;
}
</style>
